export default __webpack_public_path__ + "static/media/InsideMuscles_12.14828b03.png";